import {
  IonButton,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonSearchbar,
  IonSpinner,
  createAnimation,
} from "@ionic/react";
import { setServers } from "dns";
import {
  arrowBackOutline,
  arrowForward,
  arrowForwardOutline,
  chevronUp,
  close,
  grid,
  mic,
  searchOutline,
  searchSharp,
} from "ionicons/icons";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ContentWithBackground from "../UI/ContentWithBackground";
import {
  AdvertisingDetailsType,
  BusinessDetailsType,
  BusinessProductCategoryWithProducts,
  BussinessHomeCardData,
  CustomerDetailsType,
  StyleDataType,
  TextCartItemType,
} from "../pages/BussinessHomePage";
import BhpSearchModal from "./BhpSearchModal";
import { getSeoUrl } from "../common/commonFunctions";
import {
  useRecordUserInteractions,
  useStringToast,
  userActionsTable,
} from "../app/hooks";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getPageType,
  getPreEmptiveSearchResults,
} from "../types/constants";
import { getSessionDetails } from "../common/cookies";
import axios from "axios";
import deepCopy from "../common/deepcopy";
import {
  AdvanceCustomizationType,
  AlertWithoutExecTypes,
  CartItemTypes,
  PositionType,
} from "../types/data_types";
import AlertWithoutExec from "../UI/AlertWithoutExec";

const BhpSearchModalWraper: React.FC<{
  expandDetails?: (
    id: string | number,
    category: string,
    mode?: "PROD" | "AD"
  ) => void;
  open: boolean;
  adMaker?: boolean;
  onDidDismiss: () => void;
  vypzeePage: boolean;
  textCartItems?: TextCartItemType[];
  searchModal: {
    open: boolean;
    category: string;
    onlineOnly?: boolean;
    controls?: { fetchMode: boolean; url?: string };
    fullMarketDir?: boolean;
    floor?: string;
    disableKeyboard?: boolean;
  };
  bussinessDetailsDB: BusinessDetailsType;
  floors?: string[];
  searchCategoryClick?: (category: string) => void;
  customerDetails?: CustomerDetailsType;
  bannerButtonClick?: (url?: string) => void;
  logoImg?: { fileName: string; rotation: number; imgCss: string };
  advertisingBannerData: AdvertisingDetailsType[];
  logoImgData: string;
  buttonOverride?: {
    icon?: any;
    name?: string;
    onClick: (id: string | number) => void;
  };
  hasProducts: boolean;
  onAddFreeTextOrder: () => void;
  addOrderItemized: (name: string) => void;
  prodCategories: BusinessProductCategoryWithProducts[];
  addItemizedFromText?: (
    name: string,
    hasEntry: boolean,
    cardData: BussinessHomeCardData
  ) => void;
  cartItems?: CartItemTypes[];
  expandingImgOpen?: Function;
  handleCheckoutOpen?: () => void;
  handleChildAddToCart?: (
    type: any,
    firstTime: any,
    id: any,
    variantName: any,
    price: any
  ) => void;
  handleChildvariant?: (name: any) => void;
  handleOpenCloseCard?: (id: any) => Promise<void>;
  categoriesSel?: { open: boolean; setOpen: (inp: any) => void };
  onClickCatBtn: () => void;
  total: number;
  cartFooterJsx: any;
  styleData?: StyleDataType;
  pageSection?: "MAIN" | "SEARCH";
  recordUserInteractions?: boolean;
  searchText?: string;
  navigate?: (
    location: { obj?: PositionType; url?: string },
    shopId: string,
    shopName: string
  ) => void;
  getMarketShowGetAllData?: (
    id: string,
    idx: number,
    block: string
  ) => Promise<void>;
  getMarketBlockData?: (block: string) => Promise<void>;
  refreshingData?: boolean;
  openQuery?: () => void;
  categoryMode?: boolean;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  const [currentModalIntervalId, setCurrentModalIntervalId] = useState([]);
  const stringToast = useStringToast();
  // const enterAnimation = (baseEl: HTMLElement) => {
  //   const root = baseEl.shadowRoot;

  //   const backdropAnimation = createAnimation()
  //     .addElement(root?.querySelector("ion-backdrop")!)
  //     .fromTo("opacity", "0.01", "var(--backdrop-opacity)");

  //   const wrapperAnimation = createAnimation()
  //     .addElement(root?.querySelector(".modal-wrapper")!)
  //     .keyframes([
  //       { offset: 0, opacity: "0", transform: "scale(0)" },
  //       { offset: 1, opacity: "0.99", transform: "scale(1)" },
  //     ]);

  //   return createAnimation()
  //     .addElement(baseEl)
  //     .easing("ease-out")
  //     .duration(50)
  //     .addAnimation([backdropAnimation, wrapperAnimation]);
  // };
  const searchModalSbRef = useRef(null);
  const [search, setSearch] = useState("");
  const [preEmptiveSearch, setPreEmptiveSearch] = useState<string>("");
  const [preEmptiveSearchList, setPreEmptiveSearchList] = useState<
    { type: string; value: string }[]
  >([]);
  const recordAction = useRecordUserInteractions();

  useEffect(() => {
    console.log("Open search text ", props.searchText);
    if (props.open && props.searchText) {
      // setSearch(props.searchText);
      // setPreEmptiveSearch({ val: props.searchText, triggerPreEmpt: false });
      searchBackend(props.searchText);
    }
  }, [props.open, props.searchText]);

  // const [timeoutCbk, setTimeoutCbk] = useState<any>(null);
  const [loadingPreEmpt, setLoadingPreEmpt] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const showPrempts = !!preEmptiveSearch && preEmptiveSearch !== search;

  /*****************************************************************
   * Name : triggerBackendSearch
   * Description : Function to trigger the search
   *****************************************************************/
  const triggerBackendSearch = () => {
    const date = new Date();
    let { id, session } = getSessionDetails();
    setLoadingPreEmpt(true);

    axios
      .get(`${IDIGIZEN_BACKEND_URL}/${getPreEmptiveSearchResults}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          Authorization: API_SECURE_KEY,
          searchString: preEmptiveSearch,
          marketId: props.bussinessDetailsDB.id,
        },
      })
      .then((res) => {
        console.log("Search results ", res);
        setPreEmptiveSearchList(res.data.data);
        setLoadingPreEmpt(false);
      })
      .catch((err) => {
        setLoadingPreEmpt(false);
      });
  };

  // const triggerBackendSearch = async () => {
  //   try {
  //     const date = new Date();
  //     let { id, session } = getSessionDetails();
  //     setLoadingPreEmpt(true);
  //     let res = await axios.get(
  //       `${IDIGIZEN_BACKEND_URL}/${getPreEmptiveSearchResults}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: API_SECURE_KEY,
  //         },
  //         params: {
  //           Authorization: API_SECURE_KEY,
  //           searchString: preEmptiveSearch,
  //           marketId: props.bussinessDetailsDB.id,
  //         },
  //       }
  //     );
  //     console.log("Search results ", res);
  //     setPreEmptiveSearchList(res.data.data);
  //     setLoadingPreEmpt(false);
  //   } catch (err) {
  //     setLoadingPreEmpt(false);
  //   }
  // };
  // useEffect(() => {
  //   // if (!!timeoutRef.current) {
  //   //   clearTimeout(timeoutRef.current);
  //   // }

  //   if (!!preEmptiveSearch) {
  //     // if (!!preEmptiveSearch.triggerPreEmpt) {
  //     timeoutRef.current = setTimeout(triggerBackendSearch, 1000);
  //     // } else if (preEmptiveSearchList.length) setPreEmptiveSearchList([]);
  //   } else {
  //     setPreEmptiveSearchList([]);
  //   }
  // }, [preEmptiveSearch]);

  const searchBackend = (str: string) => {
    recordAction({
      action: userActionsTable.triggerSearch,
      pageId: props.bussinessDetailsDB.id,
      pageSection: "SEARCH",
      pageType: getPageType(
        props.bussinessDetailsDB.isMarket,
        props.bussinessDetailsDB.marketType
      ),
      notes: str,
    });
    setSearch(str);
    setPreEmptiveSearch(str);
  };

  const inPageSearch =
    !props.bussinessDetailsDB.isMarket ||
    (props.bussinessDetailsDB.isMarket &&
      (props.bussinessDetailsDB.marketType === "RWA" ||
        props.bussinessDetailsDB.marketType === "USER"));

  const searchControls = useMemo(() => {
    return {
      fetchMode: props.searchModal?.controls?.fetchMode,
      url: props.searchModal?.controls?.url,
    };
  }, [props.searchModal]);

  const expandDetails = useCallback((id, category, mode) => {
    props.expandDetails(id, category, mode);
  }, []);

  useEffect(() => {
    if (!!preEmptiveSearch) {
      if (!!timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(triggerBackendSearch, 800);
    }
  }, [preEmptiveSearch]);

  const [openAlert, setOpenAlert] = useState<AlertWithoutExecTypes>({
    message: "",
    open: false,
  });

  return (
    <>
      <AlertWithoutExec openAlert={openAlert} setOpenAlert={setOpenAlert} />
      <IonModal
        isOpen={props.open}
        onDidDismiss={() => {
          props.onDidDismiss();
          setCurrentModalIntervalId([]);
          setSearch("");
          setPreEmptiveSearch("");
          setPreEmptiveSearchList([]);
          timeoutRef.current = null;
          props?.getMarketBlockData("");
        }}
        className="bhp-show-all-promo-modal"
        onIonModalDidPresent={() => {
          if (searchModalSbRef.current && !props.searchModal.disableKeyboard) {
            setTimeout(() => {
              searchModalSbRef.current.focus();
            }, 300);
          }
        }}
        onWillDismiss={() => {
          for (const interval of currentModalIntervalId)
            clearInterval(interval);
        }}
        breakpoints={[1]}
        initialBreakpoint={1}
      >
        <IonHeader>
          <div
            className={`bhp-search-modal-header`}
            style={{
              background: props.styleData.headerBg
                ? props.styleData.headerBg
                : undefined,
              paddingTop: "20px",
            }}
          >
            <IonButton
              fill="clear"
              color={"medium"}
              size="small"
              onClick={props.onDidDismiss}
            >
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
            <div style={{ flexGrow: "1", position: "relative" }}>
              {!!inPageSearch && (
                <IonSearchbar
                  type="search"
                  className="bhp-search-modal-searchbar"
                  value={search}
                  ref={searchModalSbRef}
                  onIonChange={(e) => {
                    setSearch(e.detail.value);
                  }}
                  placeholder={`Search in ${props.bussinessDetailsDB.name}`}
                  onKeyDown={(e) => {
                    if (!!timeoutRef.current) {
                      clearTimeout(timeoutRef.current);
                    }
                    // if (!!preEmptiveSearch.triggerPreEmpt) {
                    timeoutRef.current = setTimeout(() => {
                      if (!!search) {
                        recordAction({
                          action: userActionsTable.triggerSearch,
                          pageId: props.bussinessDetailsDB.id,
                          pageSection: "SEARCH",
                          pageType: getPageType(
                            props.bussinessDetailsDB.isMarket,
                            props.bussinessDetailsDB.marketType
                          ),
                          notes: search,
                        });
                      }
                    }, 1500);
                  }}
                />
              )}
              {!inPageSearch && (
                <div
                  style={{
                    position: "relative",
                    // border: "1px solid red",
                    paddingRight: "20px",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "0px",
                      display: "flex",
                    }}
                  >
                    {!!preEmptiveSearch && (
                      <IonButton
                        size="small"
                        fill="clear"
                        color={"danger"}
                        onClick={() => {
                          setSearch("");
                          setPreEmptiveSearch("");
                        }}
                      >
                        <IonIcon icon={close} />
                      </IonButton>
                    )}
                    <IonButton
                      size="small"
                      fill="clear"
                      color={"primary"}
                      onClick={() => {
                        setOpenAlert({
                          message:
                            "You can use the mic button on your keyboard to use Speech to Text",
                          header: "Speech to Text",
                          open: true,
                        });
                      }}
                    >
                      <IonIcon icon={mic} />
                    </IonButton>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      left: "2px",
                      top: "0px",
                      zIndex: "10",
                    }}
                  >
                    <IonButton size="small" fill="clear" color={"medium"}>
                      <IonIcon icon={searchOutline} />
                    </IonButton>
                  </div>
                  <input
                    className="bhp-search-modal-search-bar"
                    placeholder={`Search in ${props.bussinessDetailsDB.name}`}
                    ref={searchModalSbRef}
                    value={preEmptiveSearch}
                    onChange={(e) => {
                      // if (!!inPageSearch) {
                      //   setSearch(e.target.value);
                      //   return;
                      // }
                      // This guard to prevent and overide of value for when the preemptive
                      // is written from searchBackend function whcih will again trigger the premptive
                      setPreEmptiveSearch(e.target.value);
                      if (!e.target.value) {
                        setSearch("");
                      }
                    }}
                    onKeyDown={(e) => {
                      // if (!!inPageSearch) return;
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (!preEmptiveSearch) {
                          stringToast("Please enter valid search input!");
                          return;
                        }
                        searchBackend(preEmptiveSearch);
                        // } else {
                        //   if (!!timeoutRef.current) {
                        //     clearTimeout(timeoutRef.current);
                        //   }
                        //   timeoutRef.current = setTimeout(triggerBackendSearch, 800);
                      }
                    }}
                  />
                </div>
              )}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  maxHeight: "500px",
                  top: "100%",
                  left: 0,
                  zIndex: "1000000000",
                  border: "1px solid var(--ion-color-medium)",
                  overflow: "hidden",
                  background: "white",
                  display: !!showPrempts ? "block" : "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "var(--ion-color-tertiary)",
                    fontSize: "1.2rem",
                    borderBottom: "1px solid var(--ion-color-medium)",
                    padding: "5px 15px",
                    position: "sticky",
                    top: 0,
                    zIndex: "100",
                    background: "white",
                  }}
                  onClick={() => {
                    searchBackend(preEmptiveSearch);
                  }}
                >
                  <div>
                    Search for <b>"{preEmptiveSearch}"</b>
                  </div>
                  <IonButton fill="clear" color={"medium"}>
                    <IonIcon icon={searchSharp} />
                  </IonButton>
                </div>
                {loadingPreEmpt && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "10px",
                    }}
                  >
                    <IonSpinner color={"medium"} />
                  </div>
                )}
                {!loadingPreEmpt &&
                  preEmptiveSearchList.map((el) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "5px 15px",
                          borderBottom: "1px solid var(--ion-color-medium)",
                        }}
                        onClick={() => {
                          searchBackend(el.value);
                        }}
                      >
                        <div>
                          <div
                            style={{
                              color: "var(--ion-color-medium)",
                              fontSize: "0.7rem",
                              paddingBottom: "5px",
                            }}
                          >
                            {el.type}
                          </div>
                          <div
                            style={{
                              color: "var(--ion-color-dark)",
                              fontSize: "1.1rem",
                            }}
                          >
                            {el.value}
                          </div>
                        </div>
                        <IonButton fill="clear" color={"medium"}>
                          <IonIcon icon={searchSharp} />
                        </IonButton>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </IonHeader>
        <ContentWithBackground>
          <div id="bhp-search-modal-content-id"></div>
          {/* <IonFab horizontal="end" vertical="bottom" slot="fixed">
          <IonFabButton
            color={"medium"}
            onClick={() => {
              // setOpenCatSel(true);
              scrollToTop()
            }}
          >
            <IonIcon icon={arrowUpOutline} />
          </IonFabButton>
        </IonFab> */}
          {props.searchModal?.controls?.fetchMode && (
            <div
              onClick={() => {
                // window.location.assign(
                //   `https://${props.bussinessDetailsDB.marketDomain}.vypzee.com`
                // );
                window.location.assign(
                  getSeoUrl(props.bussinessDetailsDB.seoUrlDetails, true)
                );
              }}
              className="bhp-search-modal-subheader"
            >
              <div>
                <b>{props.bussinessDetailsDB.marketName} Directory</b>
              </div>
              <div className="bhp-search-modal-market-visit-button">
                Visit Now <IonIcon icon={arrowForwardOutline} />
              </div>
            </div>
          )}
          {/* {getProductShopCatDisplayJsx(
          "search",
          searchModal.category,
          searchModal?.onlineOnly
        )} */}
          <BhpSearchModal
            openQuery={props.openQuery}
            refreshingData={props?.refreshingData}
            getMarketShowGetAllData={props?.getMarketShowGetAllData}
            getMarketBlockData={props?.getMarketBlockData}
            pageLocation="SEARCH"
            searchModalMode={true}
            expandDetails={expandDetails}
            adMaker={props.adMaker}
            floors={props.floors}
            initialFloor={props.searchModal.floor}
            searchCategoryClick={props.searchCategoryClick}
            bannerButtonClick={props.bannerButtonClick}
            customerDetails={props.customerDetails}
            logoImg={props.logoImg}
            currentInterval={currentModalIntervalId}
            setCurrentInterval={setCurrentModalIntervalId}
            enableAdSpace={true}
            adData={props.advertisingBannerData}
            logoImgData={props.logoImgData}
            buttonOverride={props.buttonOverride}
            listModeListing={props.bussinessDetailsDB.listModeListing}
            onAddFreeTextOrder={props.onAddFreeTextOrder}
            hasProducts={props.hasProducts}
            addOrderItemized={props.addOrderItemized}
            bussinessDetailsDB={props.bussinessDetailsDB}
            controls={searchControls}
            prodCategories={props.prodCategories}
            addItemizedFromText={props.addItemizedFromText}
            cartItems={props.cartItems}
            catFilter={props.searchModal.category}
            expandingImgOpen={props.expandingImgOpen}
            handleCheckoutOpen={props.handleCheckoutOpen}
            handleChildAddToCart={props.handleChildAddToCart}
            handleChildvariant={props.handleChildvariant}
            handleOpenCloseCard={props.handleOpenCloseCard}
            idAdder="search"
            vypzeePage={props.vypzeePage}
            onlineOnly={props.searchModal?.onlineOnly}
            search={search}
            textCartItems={props.textCartItems}
            dismiss={props.onDidDismiss}
            categoriesSel={props.categoriesSel}
            pageSection={props.pageSection}
            recordUserInteractions={props.recordUserInteractions}
            navigate={props.navigate}
            advanceCustomization={props.advanceCustomization}
          />
          {/* Clearance for IonFab */}
          {/* <div style={{ height: "100px" }}></div> */}
        </ContentWithBackground>
        {props.bussinessDetailsDB.isMarket && (
          <IonFooter>
            <div style={{ padding: "5px" }}>
              <IonButton
                size="small"
                fill="clear"
                color={"medium"}
                expand="block"
                onClick={() => {
                  const element = document.getElementById(
                    "bhp-search-modal-content-id"
                  );
                  if (element) {
                    element.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }
                }}
              >
                <IonIcon icon={chevronUp} slot="start" /> Scroll To Top
              </IonButton>
              <IonButton
                color={"dark"}
                expand="block"
                onClick={() => {
                  if (props.categoryMode) {
                    window.location.assign(
                      getSeoUrl(props.bussinessDetailsDB.seoUrlDetails)
                    );
                    return;
                  }
                  recordAction({
                    action: userActionsTable.categoryExpand,
                    pageId: props.bussinessDetailsDB.id,
                    pageSection: "SEARCH",
                    pageType: getPageType(
                      props.bussinessDetailsDB.isMarket,
                      props.bussinessDetailsDB.marketType
                    ),
                  });
                  props.onClickCatBtn();
                }}
              >
                <IonIcon
                  icon={props.categoryMode ? arrowForward : grid}
                  slot={!props.categoryMode ? "start" : "end"}
                />
                {!props.categoryMode ? "Categories" : "Explore Full Directory"}
              </IonButton>
            </div>
          </IonFooter>
        )}
        {!props.searchModal.fullMarketDir &&
          !props.bussinessDetailsDB.isMarket &&
          !!props.total &&
          props.cartFooterJsx}
      </IonModal>
    </>
  );
};

export default BhpSearchModalWraper;
